import React from 'react';
import Icon from '../atoms/Icon';

function PhoneIcon(props: any, ref: React.Ref<any>) {
  return (
    <Icon {...props} ref={ref} viewBox="0 0 19 32">
      <g fill='currentColor' fillRule='evenodd'>
        <path d="M10.2857 27.4286C10.2857 28.0583 9.77257 28.5714 9.14286 28.5714C8.51314 28.5714 8 28.0583 8 27.4286C8 26.7989 8.51314 26.2857 9.14286 26.2857C9.77257 26.2857 10.2857 26.7989 10.2857 27.4286Z"/>
        <path d="M16 3.42857C16 2.7969 15.4888 2.28571 14.8571 2.28571H3.42857C2.7969 2.28571 2.28571 2.7969 2.28571 3.42857V28.5714C2.28571 29.2031 2.7969 29.7143 3.42857 29.7143H14.8571C15.4888 29.7143 16 29.2031 16 28.5714V3.42857ZM18.2857 28.5714C18.2857 30.4655 16.7512 32 14.8571 32H3.42857C1.53453 32 0 30.4655 0 28.5714V3.42857C0 1.53453 1.53453 0 3.42857 0H14.8571C16.7512 0 18.2857 1.53453 18.2857 3.42857V28.5714Z"/>
        <path d="M11.4286 4.57144H6.85716C5.5943 4.57144 4.57144 3.54858 4.57144 2.28572H13.7143C13.7143 3.54858 12.6914 4.57144 11.4286 4.57144Z"/>
      </g>
    </Icon>
  );
}

export default React.forwardRef(PhoneIcon);